import { FC, PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'

import { Spinner } from 'assets/icons/spinner'

import { useAuthStore } from 'features/user/auth-store'

export const ProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
  const { user, loading } = useAuthStore()

  if (loading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Spinner />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" />
  }

  return <>{children}</>
}
